import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { canDeleteAccountUrl, deleteAccountUrl } from "../urls";

// Check if the user can delete the account and proceed with deletion
export const canDeleteAccountAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(
        canDeleteAccountUrl(),
        getTokenHeader(token),
      );
      return next(response.data);
    } catch (err) {
      return next({
        error: true,
        message: err.response?.data?.message,
      });
    }
  });
};

// Delete the user account
export const deleteAccountAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.delete(
        deleteAccountUrl(),
        getTokenHeader(token),
      );
      return next(response.data);
    } catch (err) {
      return next({
        error: true,
        message: err.response?.data?.message,
      });
    }
  });
};